/**
 * Auto-formats a MAC address input to uppercase hyphen-separated pairs.
 * - Replaces colons with hyphens
 * - Strips all non-hex characters
 * - Inserts hyphens between every pair of hex digits
 * - Uppercases the result
 *
 * Examples:
 *   "CC:03:7B:B8:DC:E2"  → "CC-03-7B-B8-DC-E2"
 *   "cc037bb8dce2"        → "CC-03-7B-B8-DC-E2"
 *   "CC037B"              → "CC-03-7B"
 *   "CC-03-7B"            → "CC-03-7B"  (no change)
 *
 * @param {string} raw - The raw input string
 * @returns {string} Formatted MAC address (partial or complete)
 */
export const formatMacId = (raw) => {
  if (!raw) return '';

  // Strip everything except hex characters
  const hex = raw.replace(/[^0-9a-fA-F]/g, '').toUpperCase();

  // Insert hyphens between every pair, keep trailing single digit as-is
  const parts = hex.match(/.{1,2}/g);
  if (!parts) return '';

  // Limit to 6 octets (12 hex chars) max
  return parts.slice(0, 6).join('-');
};
